/**
 * ПУБЛИЧНЫЙ API модуля import-wizard — ЕДИНСТВЕННЫЙ вход для других модулей.
 *
 * Наружу видны хуки, keys и доменные типы. Приватны: server/*, *.api.ts,
 * module.nav/rbac, *.schema.ts, components/*, pages/* (их тянут только
 * app-обёртки в src/app и внутримодульные импорты).
 *
 * NB: `ImportDataButton`/`ImportWizard` экспонируются как публичные компоненты,
 * т.к. их встраивают другие экраны (напр. тулбар дашборда).
 */

// ── Хуки (L3) ────────────────────────────────────────────────────────────────
export { useImportWizard, useBulkUpload, importWizardKeys, type WizardStep } from './import-wizard.hooks'

// ── Публичные компоненты (точки встраивания мастера импорта) ──────────────────
export { ImportDataButton, ImportWizard } from './components'

// ── DTO ресурса, реэкспортируемые хуками ──────────────────────────────────────
export type {
  UploadedFileDto,
  ImportUploadResponse,
  ImportValidateRequest,
  ImportValidateResponse,
  BulkUploadResponse,
} from './import-wizard.api'

// ── Доменные типы import-wizard ───────────────────────────────────────────────
export type {
  ParsedFile,
  ColumnMatch,
  ImportSessionData,
  ImportSessionStatus,
  ValidationResult,
  ValidationSummary,
  ImportTemplate,
  ImportPreviewResponse,
  ImportCommitResponse,
  DuplicateCandidate,
  DuplicateAction,
} from './import-wizard.types'
